<template>
  <router-view :key="$route.fullPath" />
</template>

<script>
export default {
  name: "App",
  beforeMount() {
    this.$store.dispatch("Landing/getCompanyInformation");
    this.$store.dispatch("Landing/getCompanies");
  },
};
</script>
